import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SubCategoryProviderQuestionsState = {
    subCategoryQuestions?: any[],
    providerQuestions?: any[],
};

const initialState: SubCategoryProviderQuestionsState = {
    subCategoryQuestions: [],
    providerQuestions: []
};

export const subCategoryProviderQuestionsSlice = createSlice({
    name: 'subCategoryProviderQuestions',
    initialState,
    reducers: {
        setSubCategoryQuestions: (state, action: PayloadAction<SubCategoryProviderQuestionsState>) => {
            state.subCategoryQuestions = action.payload.subCategoryQuestions;
        },
        setProviderQuestions: (state, action: PayloadAction<SubCategoryProviderQuestionsState>) => {
            state.providerQuestions = action.payload.providerQuestions;
        }
    }
});

export const { setSubCategoryQuestions, setProviderQuestions } = subCategoryProviderQuestionsSlice.actions;

export default subCategoryProviderQuestionsSlice.reducer;
